import ResponseHelper from '../libs/api/response-helper';
import DeviceStorage from '../libs/device-storage';

export const state = () => ({
  data: {
    id: '',
    name: '',
    hasAnonymous: false,
    gateway: '',
    gatewayPublicKey: ''
  }
});

export const mutations = {
  setDistributorState(state, payload) {
    state.data = payload;
  }
};

export const actions = {
  distributor({ rootState, commit }) {
    const distributorId = rootState.config.distributor.id;

    return axios
      .$get(`distributors/${distributorId}/list/released`)
      .then(function (response) {
        if (response?.length) {
          const d = response[0];

          commit('setDistributorState', {
            data: {
              id: d.id,
              name: d.name,
              hasAnonymous: d.anonymous,
              gateway: d.gateway,
              gatewayPublicKey: d.gatewayPublicKey,
              useGovLogin: d.useGovLogin,
              govClientId: d?.govClientId,
              govRedirectUri: d?.govRedirectUri
            }
          });
          return Promise.resolve(response);
        }
        return Promise.reject(response);
      })
      .catch(function (error) {
        return Promise.reject(ResponseHelper.getErrorResponse(error));
      });
  },

  addDistributor({ commit }, payload) {
    DeviceStorage.set('distributor', {
      id: payload.id,
      name: payload.name,
      hasAnonymous: payload.hasAnonymous,
      gateway: payload.gateway,
      gatewayPublicKey: payload.gatewayPublicKey,
      useGovLogin: payload.useGovLogin,
      govClientId: payload?.govClientId,
      govRedirectUri: payload?.govRedirectUri,
      hasPrivacyPolicy: payload?.hasPrivacyPolicy,
      hasTermsOfUse: payload?.hasTermsOfUse,
    });

    commit('setDistributorState', {
      data: {
        id: payload.id,
        name: payload.name,
        hasAnonymous: payload.hasAnonymous,
        gateway: payload.gateway,
        gatewayPublicKey: payload.gatewayPublicKey,
        useGovLogin: payload.useGovLogin,
        govClientId: payload?.govClientId,
        govRedirectUri: payload?.govRedirectUri
      }
    });
  }
};
